import React from "react";
import { Icons } from "../../../../config/MuiIcons.config";
import "./SpeedRunCard.style.css";
import { CircularProgress } from "@mui/material";

const SpeedRunCard = ({ activePassage, onPlayClick, loading, isChallengeCompleted }) => {
  const { isCompleted, loadingForChallenge } = isChallengeCompleted;
  return (
    <div className="speed-run-card">
      <div className="speed-run-header">
        <div className="speed-run-title-section">
          <h2 className="speed-run-title">Today's Speed Run</h2>
          <p className="speed-run-description">
            Complete the challenge in the lowest time.
          </p>
        </div>
        <div className="speed-run-timer-icon">
          <Icons.TimerIcon />
        </div>
      </div>

      <div className="speed-run-content">
        {loadingForChallenge ? (
          <CircularProgress size={30} sx={{ color: "#fff" }} />
        ) : (
          <button
            className={`speed-run-play-button ${
              isCompleted ? "is-challenge-completed" : ""
            }`}
            onClick={onPlayClick}
            disabled={loading || !activePassage || isCompleted}
          >
            {isCompleted ? (
              <>
                <Icons.CheckCircle color="inherit" />
                <span className="speed-run-play-text">
                  Challenge Completed!
                </span>
              </>
            ) : (
              <>
                <div className="speed-run-play-icon">
                  <Icons.PlayArrowIcon />
                </div>
                <span className="speed-run-play-text">Play Now</span>
              </>
            )}
          </button>
        )}

        <p className="speed-run-attempt-info">
          •{" "}
          {isCompleted
            ? "Wait for the next challenge"
            : "You get 1 attempt per game"}
        </p>
      </div>
    </div>
  );
};

export default SpeedRunCard;

